import React, { PureComponent, useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import "firebase/firestore";
import Layout, { Container } from "../components/layout";
import SEO from "../components/seo";
import db from "../utils/db";
import Header from "../components/header";
import girl from "../images/girl-horizontal.svg";
import { H1, H2, TextWrapper } from "../components/typography";
import Vacancy from "../components/vacancy";
import Wave from "../components/wave";
import Footer from "../components/footer";

const HeaderBanner = styled.div`
  //background: linear-gradient(to top, #fad961, #fb9e4a);
  padding: 56px 0px;
  position: relative;
  margin-bottom: 24px;
  z-index: 1;

  @media (max-width: 1090px) {
    padding: 0;
  }
`;

const HeaderText = styled(H1)`
  margin-bottom: 0;
  width: 40%;

  @media (max-width: 1090px) {
    width: 100%;
  }

  @media (max-width: 715px) {
    font-size: 32px;
  }
`;

const HeaderBannerImg = styled.img`
  width: 692px;
  min-height: 150px;
  max-height: 407px;
  position: absolute;
  right: 0;
  top: -112px;

  @media (max-width: 1090px) {
    position: relative;
    top: auto;
  }

  @media (max-width: 552px) {
    width: 100%;
    height: 160px;
  }
`;

const HeaderContainer = styled(Container)`
  margin-bottom: 0;
  height: 162px;
  display: flex;
  align-items: center;

  @media (max-width: 1090px) {
    height: auto;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0;
  }
`;

const VacancyH2 = styled(H2)`
  @media (max-width: 650px) {
    text-align: center;
  }
`;

export const TextLayout = styled.div`
  background: #fafafa;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 3px 35px 0 rgba(37, 38, 40, 0.08);
  margin-bottom: 60px;

  @media (max-width: 552px) {
    margin-bottom: 20px;
    box-shadow: none;

    padding: 16px;
  }
`;

export const TextLayoutWrapper = styled(Layout)`
  margin-bottom: 0;
  @media (max-width: 552px) {
    padding: 16px 0;
  }
`;

const IndexPage = () => {
  const [vacancies, setVacancies] = useState([]);
  const [isLoaded, setIsLoaded] = useState(null);

  useEffect(() => {
    db()
      .collection("vacancies")
      .get()
      .then(querySnapshot => {
        const vacancies = {};

        querySnapshot.forEach(doc => {
          vacancies[doc.id] = doc.data();
        });

        setVacancies(vacancies);
        setIsLoaded(true);
      });
  }, []);

  const departments = Object.keys(vacancies).map(vacancy => {
    return <Vacancy key={vacancy} slug={vacancy} {...vacancies[vacancy]} />;
  });

  return (
    <>
      <SEO title="Главная" />
      <Header />
      <HeaderBanner>
        <HeaderContainer>
          <HeaderText>Вакансии MyBook</HeaderText>
          <HeaderBannerImg src={girl} alt="" />
        </HeaderContainer>
      </HeaderBanner>
      <Wave />

      <TextLayoutWrapper>
        <TextLayout>
          <TextWrapper>
            <p>
              MyBook&nbsp;&mdash; крупнейший сервис для чтения книг
              по&nbsp;подписке. Миллионы читателей в&nbsp;России
              и&nbsp;СНГ.&nbsp;Сайт, мобильное приложение на&nbsp;iOS
              и&nbsp;Android. Только легальный контент&nbsp;&mdash; сотни тысяч
              книг и&nbsp;аудиокниг.&nbsp;Команда, которая любит книги
              и&nbsp;стремится сделать лучший продукт на&nbsp;рынке электронных
              книг.&nbsp;Присоединяйтесь к&nbsp;нам!
            </p>

            <b>Мы предлагаем:</b>
            <ul>
              <li>Официальное оформление по&nbsp;ТК&nbsp;РФ;</li>
              <li>Рабочая неделя пн-пт с&nbsp;гибким временем прихода;</li>
              <li>
                Офис в&nbsp;&laquo;Москва Сити&raquo;, башня
                &laquo;Меркурий&raquo;;
              </li>
              <li>Подписка на&nbsp;все книги MyBook;</li>
              <li>
                ДМС со&nbsp;стоматологией, фитнес, английский (после
                испытательного срока).
              </li>
            </ul>
          </TextWrapper>

          {departments.length > 0 && <VacancyH2>Наши вакансии</VacancyH2>}

          {departments}
        </TextLayout>
      </TextLayoutWrapper>

      <Footer />
    </>
  );
};

export default IndexPage;
